const BasicInfo = ({ t }) => {
  return (
    <>
      <h3 className="my-4 font-semibold text-primary">{t("basicInfo")}</h3>

      <section className="p-4 space-y-2 border bg-sideBar border-primary rounded-xl">
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("activityName")}:</p>
            <p className="font-semibold">دورة كاراتيه</p>
          </div>
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("category")}:</p>
            <p className="font-semibold">رياضي</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("allowedCategory")}:</p>
            <p className="font-semibold">الجميع</p>
          </div>
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("date")}:</p>
            <p className="font-semibold">20/06/2025</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("time")}:</p>
            <p className="font-semibold">4:00 - 2:00</p>
          </div>
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("registration")}:</p>
            <p className="font-semibold">20 / 18</p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-full space-y-2">
            <p className="font-medium text-mainGray">{t("desc")}</p>
            <p className="text-sm font-semibold">
              هذا النشاط مخصص للأعضاء المهتمين بتعلم فنون الكاراتيه. يقدم المدرب خبرة
              تهشام عن 10 سنوات في هذا المجال.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default BasicInfo;
